import React, { FC, Fragment, useState } from 'react';
import { Box, Button, makeStyles, Paper, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { EmptyState } from 'components';
import { useCheckedState, useProtectedClient } from 'hooks';
import { generateLink } from 'Links';

import { Header, Table, TableHeader } from '../../components/Assignments';
import { useGetAssignments } from '../../hooks';
import useDeleteAssignment from '../../updaters/useDeleteAssignment';

const useStyles = makeStyles(theme => ({
  emptyState: {
    minHeight: theme.spacing(80),
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 0, 20),
  },
}));

const Assignments: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const client = useProtectedClient();
  const checkedOptions = useCheckedState();

  const [isActive, setIsActive] = useState(true);

  const variables = {
    active: isActive,
    client_id: client.id,
  };

  const queryOptions = useGetAssignments(variables);
  const deleteMutationOptions = useDeleteAssignment(variables);

  const { isEmpty } = queryOptions;

  function renderTable() {
    if (isEmpty) {
      return (
        <Box className={classes.emptyState}>
          <EmptyState
            name="assignments"
            actionComponent={
              <Button
                color="primary"
                component={generateLink('/admin/settings/assignments/create')}
              >
                <Typography variant="subtitle2" align="center">
                  {t('admin:assignmentsFormCreate')}
                </Typography>
              </Button>
            }
          />
        </Box>
      );
    }

    return (
      <Table
        isActive={isActive}
        deleteMutationOptions={deleteMutationOptions}
        {...checkedOptions}
        {...queryOptions}
      />
    );
  }
  return (
    <Fragment>
      <Box pb={2}>
        <Header />
      </Box>

      <Paper>
        <TableHeader active={isActive} onSetActive={setIsActive} />
        {renderTable()}
      </Paper>
    </Fragment>
  );
};

export default Assignments;
